import { render, staticRenderFns } from "./DnsForm.vue?vue&type=template&id=0afff39c"
import script from "./DnsForm.vue?vue&type=script&lang=js"
export * from "./DnsForm.vue?vue&type=script&lang=js"
import style0 from "./DnsForm.vue?vue&type=style&index=0&id=0afff39c&prod&lang=scss"
import style1 from "./DnsForm.vue?vue&type=style&index=1&id=0afff39c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports